import script from "./CameraWindow.vue?vue&type=script&setup=true&lang=ts"
export * from "./CameraWindow.vue?vue&type=script&setup=true&lang=ts"

import "./CameraWindow.vue?vue&type=style&index=0&id=1d3dea9f&scoped=true&lang=css"

import exportComponent from "/Users/ra1to/Desktop/web_frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1d3dea9f"]])

export default __exports__